<template>
    <div class="relative" @mouseenter="openDropdown" @mouseleave="closeDropdown">
        <div ref="dropdownButton" :class="buttonClass"
             class="focus:outline-none font-medium inline-flex items-center leading-tight">
            <slot name="button">Кнопка</slot>
        </div>
        <div ref="dropdownMenu" v-if="isOpen" class="absolute right-0 z-10 pt-2" @click.prevent="insideToggleEvent">
            <div class="border bg-white divide-y divide-gray-100 rounded-lg shadow w-44 overflow-hidden"
                 :class="[menuClass]">
                <slot name="menu">Пусто</slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalSelect",
    props: {
        buttonClass: {
            type: String,
            default: "border border-gray-500 bg-transparent text-black text-xs rounded px-3 py-1.5"
        },
        menuClass: {
            type: String,
            default: ""
        },
        insideToggle: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isOpen: false
        };
    },
    methods: {
        openDropdown() {
            this.isOpen = true;
        },
        closeDropdown() {
            this.isOpen = false;
        },
        insideToggleEvent() {
            if (this.insideToggle) {
                this.isOpen = false;
            }
        }
    }
};
</script>

<style scoped>
</style>
